import { DemographicRadiusIndex } from "../../../../../CoStar/Api/EnterpriseSub2/Detail/index.js";
/** CoStar.Api.Listings.ViewModels.Detail.DemographicRadiusIndex */
export { DemographicRadiusIndex };
/** CoStar.Api.Listings.ViewModels.Detail.ListingPermissionLevels */
export var ListingPermissionLevels;
(function (ListingPermissionLevels) {
    ListingPermissionLevels[ListingPermissionLevels["None"] = 0] = "None";
    ListingPermissionLevels[ListingPermissionLevels["CoStarStaff"] = 1] = "CoStarStaff";
    ListingPermissionLevels[ListingPermissionLevels["LeasingContact"] = 2] = "LeasingContact";
    ListingPermissionLevels[ListingPermissionLevels["LeasingContactAdmin"] = 4] = "LeasingContactAdmin";
    ListingPermissionLevels[ListingPermissionLevels["LeasingCompanyAdmin"] = 8] = "LeasingCompanyAdmin";
})(ListingPermissionLevels || (ListingPermissionLevels = {}));
/** CoStar.Api.Listings.ViewModels.Detail.NoteType */
export var NoteType;
(function (NoteType) {
    NoteType[NoteType["None"] = 0] = "None";
    NoteType[NoteType["PropertyInternal"] = 1] = "PropertyInternal";
    NoteType[NoteType["PropertyExternal"] = 2] = "PropertyExternal";
    NoteType[NoteType["SaleExternal"] = 3] = "SaleExternal";
    NoteType[NoteType["CommissionNote"] = 4] = "CommissionNote";
    NoteType[NoteType["TenantExternal"] = 5] = "TenantExternal";
    NoteType[NoteType["TenantInternal"] = 6] = "TenantInternal";
    NoteType[NoteType["TenantTransactionInternal"] = 7] = "TenantTransactionInternal";
    NoteType[NoteType["SpaceNote"] = 8] = "SpaceNote";
    NoteType[NoteType["SpaceVacantInternal"] = 9] = "SpaceVacantInternal";
    NoteType[NoteType["SupplementalExternal"] = 10] = "SupplementalExternal";
    NoteType[NoteType["LocationInternal"] = 14] = "LocationInternal";
    NoteType[NoteType["LocationExternal"] = 15] = "LocationExternal";
    NoteType[NoteType["LocationBilling"] = 16] = "LocationBilling";
    NoteType[NoteType["CompExternal"] = 25] = "CompExternal";
    NoteType[NoteType["CompInternal"] = 26] = "CompInternal";
    NoteType[NoteType["CompSeller"] = 27] = "CompSeller";
    NoteType[NoteType["CompBuyer"] = 28] = "CompBuyer";
    NoteType[NoteType["CompManager"] = 29] = "CompManager";
    NoteType[NoteType["PropertyGroupExternal"] = 30] = "PropertyGroupExternal";
    NoteType[NoteType["PropertyGroupInternal"] = 31] = "PropertyGroupInternal";
    NoteType[NoteType["LeaseDealInternal"] = 32] = "LeaseDealInternal";
    NoteType[NoteType["LeaseDealExternal"] = 33] = "LeaseDealExternal";
    NoteType[NoteType["LandLease"] = 34] = "LandLease";
    NoteType[NoteType["LandLeaseCommission"] = 35] = "LandLeaseCommission";
    NoteType[NoteType["CompEntityInternal"] = 36] = "CompEntityInternal";
    NoteType[NoteType["CompEntityExternal"] = 37] = "CompEntityExternal";
    NoteType[NoteType["PropertyLoan"] = 38] = "PropertyLoan";
    NoteType[NoteType["PropertyResidentialExternal"] = 39] = "PropertyResidentialExternal";
    NoteType[NoteType["ListingExternal"] = 40] = "ListingExternal";
    NoteType[NoteType["AptsSalesforceNote"] = 41] = "AptsSalesforceNote";
    NoteType[NoteType["WhyYouLoveUs"] = 42] = "WhyYouLoveUs";
    NoteType[NoteType["CheckInCheckoutPolicy"] = 43] = "CheckInCheckoutPolicy";
    NoteType[NoteType["PaymentPolicy"] = 44] = "PaymentPolicy";
    NoteType[NoteType["AdvancedPaymentPolicy"] = 45] = "AdvancedPaymentPolicy";
    NoteType[NoteType["CancellationPolicy"] = 46] = "CancellationPolicy";
    NoteType[NoteType["ListingLocationDescription"] = 47] = "ListingLocationDescription";
    NoteType[NoteType["ContactExternal"] = 48] = "ContactExternal";
    NoteType[NoteType["ContactInternal"] = 49] = "ContactInternal";
    NoteType[NoteType["ListingExternalGenerated"] = 50] = "ListingExternalGenerated";
    NoteType[NoteType["DrivingDirections"] = 51] = "DrivingDirections";
    NoteType[NoteType["StudentHousingDescription"] = 52] = "StudentHousingDescription";
    NoteType[NoteType["RenterQualification"] = 53] = "RenterQualification";
    NoteType[NoteType["MarketingStakeholder1"] = 54] = "MarketingStakeholder1";
    NoteType[NoteType["MarketingStakeholder2"] = 55] = "MarketingStakeholder2";
})(NoteType || (NoteType = {}));
/** CoStar.Api.Listings.ViewModels.Detail.ListingDetailOptions */
export var ListingDetailOptions;
(function (ListingDetailOptions) {
    ListingDetailOptions[ListingDetailOptions["None"] = 0] = "None";
    ListingDetailOptions[ListingDetailOptions["RestrictedVisibility"] = 1] = "RestrictedVisibility";
    ListingDetailOptions[ListingDetailOptions["Licensed"] = 2] = "Licensed";
})(ListingDetailOptions || (ListingDetailOptions = {}));
/** CoStar.Api.Listings.ViewModels.Detail.ListingAccessControlLevelType */
export var ListingAccessControlLevelType;
(function (ListingAccessControlLevelType) {
    ListingAccessControlLevelType[ListingAccessControlLevelType["None"] = 0] = "None";
    ListingAccessControlLevelType[ListingAccessControlLevelType["Registration"] = 10] = "Registration";
    ListingAccessControlLevelType[ListingAccessControlLevelType["ConfidentialityAgreement"] = 20] = "ConfidentialityAgreement";
    ListingAccessControlLevelType[ListingAccessControlLevelType["DetailView"] = 30] = "DetailView";
})(ListingAccessControlLevelType || (ListingAccessControlLevelType = {}));
